import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetTeamUserNoteCountsQuery,
  GetTeamUserNoteCountsQueryVariables,
} from "./GetTeamUserNoteCounts.generated";

const GET_TEAM_USER_NOTE_COUNTS: TypedDocumentNode<
  GetTeamUserNoteCountsQuery,
  GetTeamUserNoteCountsQueryVariables
> = gql`
  query getTeamUserNoteCounts(
    $startDate: DateTime
    $endDate: DateTime
    $teamUuid: String
    $jobType: String
    $filter: String
    $searchQuery: String
  ) {
    teamUserNoteCounts(
      startDate: $startDate
      endDate: $endDate
      teamUuid: $teamUuid
      jobType: $jobType
      filter: $filter
      searchQuery: $searchQuery
    ) {
      noteCounts {
        userUuid
        teamUuid
        noteCount
      }
    }
  }
`;

export default GET_TEAM_USER_NOTE_COUNTS;
